import { render, staticRenderFns } from "./DialogEditOrCreate.vue?vue&type=template&id=4982af1f&scoped=true"
import script from "./DialogEditOrCreate.vue?vue&type=script&lang=js"
export * from "./DialogEditOrCreate.vue?vue&type=script&lang=js"
import style0 from "./DialogEditOrCreate.vue?vue&type=style&index=0&id=4982af1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982af1f",
  null
  
)

export default component.exports